import { useQuery } from "@tanstack/react-query";
import * as req from "@script/req.ts";

export function useRosterLatestQuery(groupId: string | null) {
  return useQuery({
    queryKey: ["rosterLatest", groupId],
    queryFn: async () => {
      return await req.roster_latest(groupId);
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
